<template>
  <label class="radio__item">
    <input
      type="radio"
      class="radio__item-input"
      hidden
      :value="value"
      :name="name"
      :disabled="isDisabled"
      @change="handleClick"
      :checked="checked"
    />
    <span class="radio__item-icon"></span>
    <span class="radio__item-extra">
      <span class="radio__item-text" v-if="label">{{ label }}</span>
      <slot v-else :value="value" :checked="checked" />
    </span>
  </label>
</template>
<script>
export default {
  name: 'radio-button',
  data() {
    return {
      isChecked: false,
    };
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    disabled: {
      type: [Boolean],
      default: false
    },
    label: String,
  },
  model: {
    prop: 'propValue',
    event: 'input',
  },
  computed: {
    isGroup() {
      return this.$parent.$options.name === 'radio-group'
    },
    isDisabled() {
      return this.$parent.disabled || this.disabled;
    },
    model: {
      get() {
        return this.isGroup ? this.$parent.value : this.propValue;
      },
      set(newValue) {
        this.isGroup
          ? this.$parent.$emit('input', newValue)
          : this.$emit('input', newValue);
      }
    },
    name() {
      return this.isGroup ? this.$parent.name : this.name;
    },
    checked() {
      return this.isGroup ? this.$parent.value === this.value : this.isChecked;
    }
  },
  methods: {
    handleClick(event) {
      if (!this.isDisabled) {
        this.model = this.value;
        this.isChecked = true;
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>